import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import columnDefinitions from '../../shared/columnDefinitions/chartOfAccounts';

export default ({
  periodName,
  chartName,
  chartAccounts,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
  environmentSuffix,
}) => {
  const sheetData = [
    {
      name: 'Chart Detail',
      type: SheetExportTypes.GRID,
      columnDefinitions,
      data: chartAccounts,
      options: {
        shouldDisplayZero,
        hideDecimals,
        negativeMinus,
      },
    },
    {
      name: 'Metadata',
      type: SheetExportTypes.CUSTOM,
      data: [],
      options: {
        addTimestamp: true,
      },
    },
  ];

  xlsxExport({
    sheetData,
    metadata: {
      fileName: `TLS_Chart_${periodName}_${chartName}${environmentSuffix}`,
      disableHeaderRendering: true,
    },
  });
};
